import styled from 'styled-components'
import { HStack } from '../../global/styles'

// eslint-disable-next-line import/prefer-default-export
export const LogoWrap = styled(HStack)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
`
